import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * A white card with a heading + subheading — the mobile equivalent of the
 * desktop `WhiteBox` + `WhiteBoxHeader` pair the profile page is built from.
 * Matches the card treatment already used across mobile (Performance's
 * "Your attempted assessments").
 */
export default function Section({ heading, subheading, children }) {
  return (
    <Box
      sx={{
        bgcolor: "shades.clr-white-900",
        border: "1px solid",
        borderColor: "neutral.clr-100",
        borderRadius: 3,
        p: 4,
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <Box>
        <Typography variant="h6-semiBold" color="neutral.clr-800">
          {heading}
        </Typography>
        {subheading && (
          <Typography
            variant="body02-regular"
            color="neutral.clr-500"
            sx={{ mt: 1, display: "block" }}
          >
            {subheading}
          </Typography>
        )}
      </Box>

      {children}
    </Box>
  );
}
